import { combineReducers } from '@reduxjs/toolkit'

import applicationsReducer from './applicationsSlice'
import authReducer from './authSlice'
import applicationReducer from './applicationSlice'
import placementsReducer from './placementsSlice'
import placementReducer from './placementSlice'
import createApplicationReducer from './createApplicationSlice'

const rootReducer = combineReducers({
  auth: authReducer,
  applications: applicationsReducer,
  application: applicationReducer,
  placements: placementsReducer,
  placement: placementReducer,
  createApplication: createApplicationReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
